import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, Button, Form, FormGroup, Label, Input, Badge, Modal, ModalHeader, ModalBody, ModalFooter, Alert } from "reactstrap";
import "./InternStyling.css"; // Import CSS

const API_URL = "https://app.rlagency.id/api_internship/batch.php";

const BatchManagement = () => {
  const [batches, setBatches] = useState([]);
  const [batchName, setBatchName] = useState("");
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [confirmCode, setConfirmCode] = useState(""); // Kode konfirmasi
  const [errorMessage, setErrorMessage] = useState(""); // State untuk pesan error
  const CONFIRMATION_CODE = "rla165165"; // Kode konfirmasi tetap

  useEffect(() => {
    fetchBatches();
  }, []);

  // Ambil data batch dari API
  const fetchBatches = async () => {
    setLoading(true);
    try {
      const response = await axios.get(API_URL);
      console.log("Response dari API:", response.data);
      setBatches(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Error fetching batches:", error);
      setBatches([]);
    }
    setLoading(false);
  };

  // Toggle Modal
  const toggleModal = () => {
    setModal(!modal);
    setErrorMessage(""); // Reset error saat modal dibuka/tutup
  };

  // Handle tombol tambah batch
  const handleAddBatchClick = () => {
    if (!batchName.trim()) {
      setErrorMessage("Nama batch tidak boleh kosong!");
      return;
    }
    toggleModal(); // Tampilkan modal konfirmasi
  };

  // Tambah batch setelah konfirmasi
  const addBatch = async () => {
    if (confirmCode !== CONFIRMATION_CODE) {
      setErrorMessage("Kode konfirmasi salah!"); // Set pesan error
      return;
    }

    try {
      await axios.post(API_URL, { batch_name: batchName });
      setBatchName("");
      setConfirmCode(""); // Reset kode konfirmasi
      toggleModal();
      fetchBatches();
    } catch (error) {
      console.error("Error adding batch:", error);
      setErrorMessage("Gagal menambahkan batch. Silakan coba lagi!");
    }
  };

  // Set batch aktif
  const setActiveBatch = async (id) => {
    try {
      await axios.put(API_URL, { id });
      fetchBatches();
    } catch (error) {
      console.error("Error setting active batch:", error);
      setErrorMessage("Gagal mengaktifkan batch.");
    }
  };

  return (
    <div>
      {/* Form Tambah Batch */}
      <Form className="add-input-head">
        <FormGroup>
          <Input
            type="text"
            id="batchName"
            value={batchName}
            onChange={(e) => setBatchName(e.target.value)}
            placeholder="Masukkan nama batch baru"
          />
        </FormGroup>
        <Button color="primary" onClick={handleAddBatchClick}>Tambah Batch Baru</Button>
      </Form>

      {/* Modal Konfirmasi */}
      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Konfirmasi Tambah Batch</ModalHeader>
        <ModalBody>
          {/* Tampilkan Alert jika ada error */}
          {errorMessage && <Alert color="danger">{errorMessage}</Alert>}

          <p>
            Internship dengan <strong>"{batchName}"</strong> akan ditambahkan. Apakah Anda yakin?
          </p>
          <FormGroup>
            <Label>Kode Konfirmasi:</Label>
            <Input
              type="text"
              value={confirmCode}
              onChange={(e) => setConfirmCode(e.target.value)}
              placeholder="Masukkan kode konfirmasi"
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={toggleModal}>Batal</Button>
          <Button color="success" onClick={addBatch}>Konfirmasi</Button>
        </ModalFooter>
      </Modal>

      {/* Tabel Daftar Batch */}
      {loading ? <p>Loading...</p> : (
        <Table bordered>
          <thead>
            <tr>
              <th>No.</th>
              <th>Nama Batch</th>
              <th>Status</th>
              <th>Aksi</th>
            </tr>
          </thead>
          <tbody>
            {(batches || []).map((batch, index) => (
              <tr key={batch.id}>
                <td>{index + 1}</td>
                <td>{batch.batch_name}</td>
                <td>
                  {parseInt(batch.status) === 1 ? (
                    <Badge color="success" className="badge-status">Aktif</Badge>
                  ) : (
                    <Badge color="danger" className="badge-status">Non-Aktif</Badge>
                  )}
                </td>
                <td>
                  {parseInt(batch.status) === 0 && (
                    <Button color="primary" className="btn-batch" onClick={() => setActiveBatch(batch.id)}>
                      Set Aktif
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
};

export default BatchManagement;
